<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.quantidade"
                        label="Quantidade"
                        number
                        v-model="model.quantidade"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :disabled="!material.possuiLote"
                        :validations="validations.lote"
                        label="Lote"
                        uppercase
                        v-model="model.lote"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-date-picker
                        :disabled="!material.possuiLote"
                        :validations="validations.validadeLote"
                        label="Validade do lote"
                        v-model="model.validadeLote"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.valorTotal"
                        label="Valor total"
                        ref="ValorTotal"
                        v-model="model.valorTotal"
                        v-money="money"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!model.quantidade || formatSumMoney(model.valorTotal) === 0"
                        :validations="validations.valorUnitario"
                        label="Valor unitário"
                        ref="ValorUnitario"
                        v-model="model.valorUnitario"
                        v-money="money"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="data.form.integracaoBnafarMedicamentos.length > 0">
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.integracaoBnafarMedicamentos"
                        :validations="validations.integracaoBnafarMedicamento"
                        label="Medicamento OBM"
                        show-default-option
                        text-field="descricao"
                        v-model="model.integracaoBnafarMedicamentoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.codigoBarras"
                        label="Código de barras"
                        number
                        v-model="model.codigoBarras"
                    />
                </rkm-col>

                 <rkm-col cols="4">
                    <rkm-form-input-autocomplete
                        :repository="repositories.fabricante"
                        :search-fields="autocompleteFields.fabricante"
                        :validations="validations.fabricante"
                        label="Fabricante"
                        uppercase
                        v-model="model.fabricante"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-button
                                @click="$refs.ModalFabricante.open()"
                                color="primary"
                                title="Cadastrar fabricante"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="repositories.fornecedor"
                        :search-fields="autocompleteFields.fornecedor"
                        :validations="validations.fornecedor"
                        label="Fornecedor"
                        uppercase
                        text-field="nomeFantasia"
                        v-model="model.fornecedor"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-button
                                @click="$refs.ModalFornecedor.open()"
                                color="primary"
                                title="Cadastrar fornecedor"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ModalFabricante
            @save="model.fabricante = $event"
            ref="ModalFabricante"
        />

        <ModalFornecedor
            @save="model.fornecedor = $event"
            ref="ModalFornecedor"
        />
    </div>
</template>

<script>
// Components
import ModalFabricante from '@/components/cadastro/fabricante/Modal'
import ModalFornecedor from '@/components/cadastro/fornecedor/Modal'

//Directives
import { VMoney } from 'v-money'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, stringCase, object, data, formats } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
    components: { ModalFabricante, ModalFornecedor },
    computed: {
        autocompleteFields() {

            return {
                fabricante: [
                    { key: 'nome', searchable: true },
                ],
                fornecedor: [
                    { key: 'nome_fantasia', searchable: true },
                ],
            }
        },
        validations() {

            return {
                material: {
                    required: true,
                },
                integracaoBnafarMedicamento: {
                    required: false,
                },
                quantidade: {
                    required: true,
                    min_value: 1,
                    max: 8,
                },
                lote: {
                    required: this.material.possuiLote,
                    max: 15,
                },
                validadeLote: {
                    required: this.material.possuiLote,
                },
                valorTotal: {
                    required: true,
                    min_value: 0.000001,
                    max: 17,
                },
                valorUnitario: {
                    required: true,
                    min_value: 0.000001,
                    max: 17,
                },
                codigoBarras: {
                    min: 13,
                    max: 13,
                },
                fabricante: {
                    required: !!this.material.hasVinculoBnafar
                },
                fornecedor: {},
            }
        },
    },
    created() {

        this.repositories = {
            entradaInicial: this.getConectaSusRepository('almoxarifado.entradaInicial'),
            fabricante: this.getConectaSusRepository('cadastro.fabricante'),
            fornecedor: this.getConectaSusRepository('cadastro.fornecedor'),
        }
    },
    data: () => ({
        model: {
            integracaoBnafarMedicamentoId: null,
            quantidade: null,
            lote: null,
            validadeLote: null,
            valorTotal: '0,000000',
            valorUnitario: '0,000000',
            codigoBarras: null,
            fabricante: null,
            fornecedor: null,
        },
        money: {
            decimal: ',',
            thousands: '.',
            suffix: '',
            precision: 6,
            masked: false
        },
    }),
    directives: { money: VMoney },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            if (this.material.possuiLote) {

                if (this.hasLoteIncluso()) {

                    this.showValidationNotification('O mesmo lote já foi incluso.')

                    return;
                }
            }

            const entrada = this.clone(this.model)

            entrada.integracaoBnafarMedicamento = this.data.form.integracaoBnafarMedicamentos.find(integracaoBnafarMedicamento => integracaoBnafarMedicamento.id === entrada.integracaoBnafarMedicamentoId)

            if (entrada.validadeLote) {

                entrada.validadeLote = moment(entrada.validadeLote).format('DD/MM/YYYY')
            }

            this.material.entradas.push(entrada)
            this.resetForm()
        },
        hasLoteIncluso() {

            return !!this.material.entradas.find(e => e.lote === this.model.lote)
        },
        resetForm() {

            this.model.integracaoBnafarMedicamentoId = null
            this.model.quantidade = null
            this.model.lote = null
            this.model.validadeLote = null

            this.model.valorTotal = '0,000000'
            this.$refs.ValorTotal.$el.getElementsByTagName('input')[0].value = '0,000000'

            this.model.codigoBarras = null
            this.model.fabricante = null
            this.model.fornecedor = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        setValorUnitario() {

            let valorUnitario = 0.0

            const quantidade = parseInt(this.model.quantidade)
            const valorTotal = this.formatSumMoney(this.model.valorTotal)

            if (quantidade > 0 && valorTotal > 0) {

                valorUnitario = valorTotal / quantidade
            }

            valorUnitario = this.formatMoney(valorUnitario, 6)

            this.model.valorUnitario = valorUnitario
            this.$refs.ValorUnitario.$el.getElementsByTagName('input')[0].value = valorUnitario
        },
        save() {

            this.showConfirmation(
                'Após salvar não será mais possível realizar entradas deste material por esta funcionalidade. '
                    + 'Futuros ajustes deverão ser realizados pela funcionalidade Inventário. Deseja continuar?',
                async () => this.handleSave(),
            )
        },
        handleSave() {

            this.setLoading()

            this.repositories.entradaInicial.store(this.prepareData())
                .then(() => {

                    this.showSaveNotification()
                    this.$emit('save')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const data = {
                materialId: this.material.id,
                entradas: this.clone(this.material.entradas)
            }

            data.entradas.map(entrada => {

                entrada.quantidade = parseInt(entrada.quantidade)
                entrada.valorTotal = this.formatSumMoney(entrada.valorTotal)
                entrada.valorUnitario = this.formatSumMoney(entrada.valorUnitario)

                this.createIdKeysToObject(entrada, [
                    'fabricante',
                    'fornecedor',
                ])

                this.formateDates(entrada, [
                    'validadeLote'
                ], 'DD/MM/YYYY')
            })

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [ repository, error, stringCase, object, data, formats ],
    props: {
        data: { type: Object, required: true },
        material: { type: Object, required: true },
    },
    watch: {
        'model.quantidade': function () {

            this.setValorUnitario()
        },
        'model.valorTotal': function () {
            this.data.form.integracaoBnafarMedicamentos = []
            this.model.integracaoBnafarMedicamentoId = null

            this.setValorUnitario()
        },
    }
}
</script>